import classNames from "classnames";
import { forwardRef, HTMLAttributes } from "react";

import { StyledTooltip, TooltipArrow, TooltipLabel, TooltipWrapper } from "./Tooltip.styled";

export type TooltipProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * set tooltip color
   * @type {"black", "white"}
   * @default {"black"}
   */
  color?: "black" | "white";
  /**
   * Set tooltip position
   * @type {"top" | "bottom" | "left" | "right" | "top-left" | "top-right" | "bottom-left" | "bottom-right"}
   * @default {"top"}
   */
  position?: "top" | "bottom" | "left" | "right" | "top-left" | "top-right" | "bottom-left" | "bottom-right";
};

const defaultProps: TooltipProps = {
  color: "black",
  position: "top"
};

const TooltipComponent = forwardRef<HTMLDivElement, TooltipProps>((props, ref) => {
  const { children, className, color, position, ...restProps } = props;
  const tooltipClass = classNames("c-tooltip", `c-tooltip--${position}`, className);

  return (
    <StyledTooltip ref={ref} className={tooltipClass} data-testid="qa-tooltip" color={color} {...restProps}>
      <TooltipArrow className="c-tooltip__arrow" data-testid="qa-tooltip__arrow" color={color}></TooltipArrow>
      <TooltipLabel className="c-tooltip__label" data-testid="qa-tooltip__label" color={color}>
        {children}
      </TooltipLabel>
    </StyledTooltip>
  );
});

TooltipComponent.defaultProps = defaultProps;

const Tooltip = Object.assign(TooltipComponent, {
  /**
   * Outside wrapper of the tooltip
   */
  Wrapper: TooltipWrapper
});

export default Tooltip;
